var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_-_white",
    "data-name": "logo - white",
    transform: "translate(-179.344 -225.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9631",
    "data-name": "Group 9631",
    transform: "translate(179.344 225.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9629",
    "data-name": "Group 9629",
    transform: "translate(9.787 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26384",
    "data-name": "Path 26384",
    d: "M218.04,225.1v10.422c.038,0,.074.006.113.006a10.315,10.315,0,0,0,10.314-10.314c0-.039-.005-.075-.006-.114Z",
    transform: "translate(-218.04 -225.1)",
    fill: "#f7be00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26385",
    "data-name": "Path 26385",
    d: "M228.467,302.439c-.038,0-.075-.006-.113-.006a10.315,10.315,0,0,0-10.314,10.314c0,.039.005.075.006.114h10.421Z",
    transform: "translate(-218.04 -282.861)",
    fill: "#965ec7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9630",
    "data-name": "Group 9630",
    transform: "translate(0 9.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26386",
    "data-name": "Path 26386",
    d: "M179.344,274.165h10.422c0-.038.006-.075.006-.113a10.314,10.314,0,0,0-10.314-10.314c-.038,0-.075.005-.113.006Z",
    transform: "translate(-179.344 -263.738)",
    fill: "#3d7cc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26387",
    "data-name": "Path 26387",
    d: "M256.741,263.738c0,.038-.006.075-.006.113a10.314,10.314,0,0,0,10.315,10.315c.037,0,.074-.005.112-.006V263.738Z",
    transform: "translate(-237.162 -263.738)",
    fill: "#ff8300"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLogo);
export default __webpack_public_path__ + "static/media/mobileLogo.20cc288f3a9c3152974d5dd9f6fb9222.svg";
export { ForwardRef as ReactComponent };